export const REGISTER_LOADING="REGISTER_LOADING"
export const REGISTER_SUCCESS="REGISTER_SUCCESS"
export const REGISTER_FAILURE="REGISTER_FAILURE"

export const LOGIN_LOADING="LOGIN_LOADING"
export const LOGIN_SUCCESS="LOGIN_SUCCESS"
export const LOGIN_FAILURE="LOGIN_FAILURE"

export const LOGOUT_SUCCESS="LOGOUT_SUCCESS"

